import * as React from 'react';

import * as styles from './RedesignedLabelsContainer.css';

type TRedesignedLabelsContainerProps = {
  visited: boolean;
};

export const RedesignedLabelsContainer: React.FC<TRedesignedLabelsContainerProps> = ({ visited }) => {
  if (!visited) {
    return null;
  }

  return (
    <div className={styles['labels']}>
      <span className={styles['visited']}>Вы смотрели</span>
    </div>
  );
};
